import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {RouterModule} from "@angular/router";
import {DynamicDialogModule} from "primeng/dynamicdialog";
import {ModalHeaderView} from "../../common/components/modal-header/_views/modal-header.view";
import {ModalFooterView} from "../../common/components/modal-footer/_views/modal-footer.view";
import {MatButton, MatButtonModule} from "@angular/material/button";
import {ViewTitleView} from "../../common/components/view-title/_views/view-title.view";
import {ViewSubTitleView} from "../../common/components/view-sub-title/_views/view-sub-title.view";
import {ViewActionBarView} from "../../common/components/view-action-bar/_views/view-action-bar.view";
import {AccessControlDirective} from "../../common/directives/access-control.directive";
import {ViewFooterView} from "../../common/components/view-footer/_views/view-footer.view";
import {ProgressBarView} from "../../common/components/progress-bar/_views/progress-bar.view";
import {FileUploadView} from "../../common/components/file-upload/_views/file-upload.view";
import {MatIconModule} from "@angular/material/icon";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {ConcatenatePipe} from "../../common/pipes/concatenate.pipe";
import {AccordionModule} from "primeng/accordion";
import {DeleteEntityView} from "../../common/components/delete-entity/_views/delete-entity.view";
import {TreeModule} from "primeng/tree";
import {OnlyNumberDirective} from "../../common/directives/only-number.directive";
import {
  NgClickOutsideAttachOutsideDirective,
  NgClickOutsideDelayOutsideDirective,
  NgClickOutsideDirective,
  NgClickOutsideExcludeDirective
} from "ng-click-outside2";
import {
  EntitySelectionDropdownView
} from "../../common/components/entity-selection-dropdown/_views/entity-selection-dropdown.view";
import {NgSelectModule} from "@ng-select/ng-select";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatRadioModule} from "@angular/material/radio";
import {NouisliderModule} from "ng2-nouislider";
import {Ng2FittextModule} from "ng2-fittext";
import {UserAvatarView} from "../../common/components/user-avatar/_views/user-avatar.view";
import {TruncatePipe} from "../../common/pipes/truncate.pipe";
import {SplitButtonModule} from "primeng/splitbutton";
import {OverlayPanelModule} from "primeng/overlaypanel";
import {ScrollPanelModule} from "primeng/scrollpanel";
import {DropdownModule} from "primeng/dropdown";
import {CalendarModule} from "primeng/calendar";
import {SliderModule} from "primeng/slider";
import {SidebarModule} from "primeng/sidebar";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {ProgressBarModule} from "primeng/progressbar";
import {AlertInstanceView} from "../../common/components/alert-instance/_views/alert-instance.view";
import {NotificationListView} from "../../common/components/notification-list/_views/notification-list.view";
import {BadgeModule} from "primeng/badge";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {HumaniseSecondsPipe} from "../../common/pipes/humanise-seconds.pipe";
import {NavigatorBarView} from "../../common/components/navigator-bar/_views/navigator-bar.view";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {QuillModule} from "ngx-quill";
import {AlertFeedbackView} from "../../common/components/alert-feedback/_views/alert-feedback.view";
import {AlertCommentView} from "../../common/components/alert-comment/_views/alert-comment.view";
import {AlertViewModalView} from "../../common/components/alert-view-modal/_views/alert-view-modal.view";
import {
  AlertViewModalHeaderView
} from "../../common/components/alert-view-modal/alert-view-modal-header/_views/alert-view-modal-header.view";
import {ButtonModule} from "primeng/button";
import {ChipModule} from "primeng/chip";

// Following rules only applied to shared modules and not feature modules or core module:

// All shared modules will be marked with Level 1, 2, 3, 4, ...
// A shared module may import another shared module IF AND ONLY IF its level is higher than the imported module(s).
// Example: Level-2 shared module may import Level-1 shared module. Level-2 shared module cannot import Level-3 shared module. Level-2 shared module cannot import another Level-2 shared module. Level-1 shared module CANNOT import any other shared module.
// Feature modules can import any number of shared modules without restrictions.
// When creating a new shared module, the assigned level should be 1 higher than the highest-level shared module needed.
// Example: If the new shared module only needs the SharedModule (Level-1), then this new shared module should be marked as Level-2. If new shared module needs a Level-2 module, then the new shared module will be marked as Level-3.

// Level 1
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatRadioModule,
    NouisliderModule,
    DynamicDialogModule,
    TooltipModule,
    AccordionModule,
    TreeModule,
    ButtonModule,
    SplitButtonModule,
    OverlayPanelModule,
    ScrollPanelModule,
    DropdownModule,
    CalendarModule,
    SidebarModule,
    SliderModule,
    NgSelectModule,
    Ng2FittextModule,
    NgClickOutsideDirective,
    NgClickOutsideDelayOutsideDirective,
    NgClickOutsideExcludeDirective,
    NgClickOutsideAttachOutsideDirective,
    MatProgressBarModule,
    ProgressBarModule,
    BadgeModule,
    ChipModule,
    MatProgressSpinnerModule,
    QuillModule,
  ],
  declarations: [
    AccessControlDirective,
    OnlyNumberDirective,
    ConcatenatePipe,
    TruncatePipe,
    HumaniseSecondsPipe,
    ModalHeaderView,
    ModalFooterView,
    ViewTitleView,
    ViewSubTitleView,
    ViewActionBarView,
    ViewFooterView,
    ProgressBarView,
    FileUploadView,
    DeleteEntityView,
    EntitySelectionDropdownView,
    UserAvatarView,
    AlertFeedbackView,
    AlertCommentView,
    AlertViewModalView,
    AlertViewModalHeaderView,
    AlertInstanceView,
    NotificationListView,
    NavigatorBarView,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatRadioModule,
    NouisliderModule,
    DynamicDialogModule,
    TooltipModule,
    AccordionModule,
    TreeModule,
    ButtonModule,
    SplitButtonModule,
    OverlayPanelModule,
    ScrollPanelModule,
    DropdownModule,
    CalendarModule,
    SidebarModule,
    SliderModule,
    NgSelectModule,
    Ng2FittextModule,
    AccessControlDirective,
    OnlyNumberDirective,
    NgClickOutsideDirective,
    NgClickOutsideDelayOutsideDirective,
    NgClickOutsideExcludeDirective,
    NgClickOutsideAttachOutsideDirective,
    ConcatenatePipe,
    HumaniseSecondsPipe,
    TruncatePipe,
    ModalHeaderView,
    ModalFooterView,
    ViewTitleView,
    ViewSubTitleView,
    ViewActionBarView,
    ViewFooterView,
    ProgressBarView,
    FileUploadView,
    DeleteEntityView,
    EntitySelectionDropdownView,
    UserAvatarView,
    MatProgressBarModule,
    ProgressBarModule,
    AlertFeedbackView,
    AlertCommentView,
    AlertViewModalView,
    AlertViewModalHeaderView,
    AlertInstanceView,
    NotificationListView,
    BadgeModule,
    NavigatorBarView,
    MatProgressSpinnerModule,
    QuillModule,
  ]
})
export class SharedModule {

}
